import { render, staticRenderFns } from "./MyIndex.vue?vue&type=template&id=15d9754e"
import script from "./MyIndex.vue?vue&type=script&lang=js"
export * from "./MyIndex.vue?vue&type=script&lang=js"
import style0 from "./MyIndex.vue?vue&type=style&index=0&id=15d9754e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports